// React
import React from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";

// CSS
import "./Carousell.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Carousell = () => {
  return (
    <div className="container-md">
      <Carousel nextLabel={""} prevLabel={""}>
        {/* cambiar  */}
        <Carousel.Item>
          <Link to="/categoria/linea-edu-train">
            <img
              className="d-block w-100"
              src="/img/homeBanners/banner0.webp"
              alt="Banner home"
            />
          </Link>
        </Carousel.Item>

        <Carousel.Item>
          <a href="/files/Catalogo_Requiez_A24-25.pdf" target="_blank">
            <img
              className="d-block w-100"
              src="/img/homeBanners/banner1.webp"
              alt="Banner home"
            />
          </a>
        </Carousel.Item>
        <Carousel.Item>
          <a href="https://requiez.com/blog/NOM-037">
            <img
              className="d-block w-100"
              src="/img/homeBanners/banner2.webp"
              alt="Banner home"
            />
          </a>
        </Carousel.Item>

        <Carousel.Item>
          <a href="https://requiez.com/blog/ley-silla">
            <img
              className="d-block w-100"
              src="/img/homeBanners/banner3.webp"
              alt="Banner home"
            />
          </a>
        </Carousel.Item>

        <Carousel.Item>
          <a href="https://requiez.com/producto/re-9100">
            <img
              className="d-block w-100"
              src="/img/homeBanners/banner4.webp"
              alt="Banner home"
            />
          </a>
        </Carousel.Item>


      </Carousel>
    </div>
  );
};

export default Carousell;
